import { useTranslation } from '@spcc/core'
import { MapPin } from '@spcc/uikit'
import { StatsWidget, StatsWidgetGrid } from '@spcc/uikit'
import type { AddressbookStatsProps } from '../types'

export function AddressbookStats({
  stats,
}: AddressbookStatsProps) {
  const { t } = useTranslation()

  return (
    <StatsWidgetGrid columns={2}>
      <StatsWidget
        label={t('addressbook.total')}
        value={stats.total}
        icon={MapPin}
        color="primary"
      />
    </StatsWidgetGrid>
  )
}
